module.exports = __webpack_public_path__ + "media/02in memory of.3f12ce59.mp3";